import React from 'react';

import emailPng from './images/email.png';
import fbPng from './images/facebook.png';
import instagramPng from './images/instagram.png';
import linkedinPng from './images/linkedin.png';

function LinkLi(url, imageUrl) {
  return (
    <li>
      <a href={url}>
        <img alt={url} src={imageUrl}/>
      </a>
    </li>
  );
}

function Header() {
  return (
    <footer>
      <div className="copyright">
        <span className="c">©</span>
        <span>Lana Batyrova</span>
      </div>

      <nav className="social-apps">
        <ul>
          {LinkLi("mailto:lana.batyrova7@gmail.com?subject=Hi!", emailPng)}
          {LinkLi("https://www.facebook.com/lana.batyrova.77", fbPng)}
          {LinkLi("https://www.instagram.com/lanabatyrova_/", instagramPng)}
          {LinkLi("https://ca.linkedin.com/in/lana-batyrova", linkedinPng)}
        </ul>
      </nav>
    </footer>
  );
}

export default Header;
